import React, { lazy, Suspense, useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import axios from "axios";
import { env } from "configs/EnvironmentConfig";
import navigationVendorConfig from "configs/NavigationVendorConfig";
export const VendorViews = () => {
  const [stnk, setStnk] = useState(false);
  const [spk, setSpk] = useState(false);
  const getData = () => {
    axios
      .get(env.API + "/user/auth/user", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const data = res.data.data.role.permissions;
        data.forEach((d) => {
          if (d == "MANAGE_STNK") {
            setStnk(true);
          }
        });
      })
      .catch((e) => {});
  };
  useEffect(() => {
    // setError(true);

    // if (!data.length) {
    //  showToken(setTokenFound);
    getData();
    // let newArr = [
    //   {
    //     key: "data-vendor/detail",
    //     path: `${ADMIN_PREFIX_PATH}/data_vendor/:id`,
    //   },
    // ];

    // newArr.map((res) => {
    //   navigationCafeConfig.push(res);
    // });
    // }
  }, []);

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        {navigationVendorConfig.map((res, i) => {
          return (
            <Route
              key={i}
              path={res.path}
              component={lazy(() => import("./" + res.key + "/index"))}
            />
          );
        })}
        <Route
          path={"/vendor/laporan_penjualan/:id"}
          component={lazy(() => import("./laporan-penjualan/detail"))}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(VendorViews);
